export default "__VITE_ASSET__DoWNQsQa__"